<template>
  <v-dialog v-model="dialog" @input="cancel" width="500">
    <v-card>
      <v-card-title class="title">Invalidar Infração</v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" sm="6" md="12">
              <v-select
                v-model="justificativa"
                :items="justificativas"
                label="Escolha a Justificativa"
                solo
                required
                :rules="justificativaRules"
              ></v-select>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="primary" outlined @click="cancel">Fechar</v-btn>
        <v-btn color="primary" @click="confirm(justificativa)">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import urlApi from "@/routes/urlApi";

export default {
  name: "ModalInvalidarAnalise",
  props: ["show"],
  data() {
    return {
      dialog: false,
      valid: true,
      id_justificativa: "",
      justificativa: "",
      justificativaRules: [(v) => !!v || "Justificativa é obrigatória"],
      justificativas: [],
    };
  },
  methods: {
    // salvarInvalidacao() {
    //   if (this.$refs.form.validate()) {
    //     this.$store
    //       .dispatch("lote/request_analise", {
    //         action: "rejeita",
    //         dados: { observacao: this.justificativa }
    //       })
    //       .then(() => {
    //         this.$toasted.global.defaultSuccess();
    //         this.fechar();
    //       });
    //   }
    // },
    // fechar() {
    //   this.$emit("fechar");
    // },
    open() {
      return new Promise((resolve, reject) => {
        this.loadJustificativas();
        this.dialog = true;
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    cancel() {
      this.reject();
      this.close();
    },
    async confirm(justificativa) {
      if (!this.$refs.form.validate()) return;
      this.resolve(justificativa);
      this.justificativa = "";
      this.close();
    },
    close() {
      this.$refs.form.reset();
      this.dialog = false;
    },
    loadJustificativas() {
      this.$http.get(urlApi + "/justificativas").then((res) => {
        console.log(res.data);
        this.justificativas = res.data.data.map((item) => {
          return { text: item.justificativa, value: item.id_justificativa };
        });
      });
    },
  },
  mounted() {
  },
};
</script>
